<template>
  <RenderCacheable
    :cache-key="navigationCacheKey"
    :no-cache="componentCachingDisabled"
  >
    <NavigationContent :categories-container="categoriesContainer" />
  </RenderCacheable>
</template>

<script lang="ts">

import NavigationContent from './NavigationContent.vue';

import type { Category } from '~~/types/commercetools';

import { enableHTMLScroll, disableHTMLScroll } from '~~/helpers/htmlScroll';
import { useCachingQueryParams } from '~/composables/useCachingQueryParams';
import { useNavigationState } from '~/composables/useNavigationState';

export default defineComponent({
  name: 'NavigationWrapper',

  components: {
    NavigationContent,
  },

  props: {
    categoriesContainer: {
      type: Array as PropType<Category[]>,
      default: () => {

        return [];
      
      },
    },
    topLevelDomain: {
      type: String,
      required: true,
    },
    languageAndCountry: {
      type: String,
      required: true,
    },
  },

  setup(props) {

    const { isNavigationOpen } = useNavigationState();

    const { componentCachingDisabled } = useCachingQueryParams();

    const navigationCacheKey = computed(() =>
      `navigation-${props.languageAndCountry}`,
    );

    watch(isNavigationOpen, (value) => {

      // if sidebar is open we want to disable the html scroll
      if (import.meta.server) {

        return;

      }

      if (value) {

        disableHTMLScroll();
      
      } else {

        enableHTMLScroll();
      
      }
    
    }, { immediate: true });

    return {
      navigationCacheKey,
      componentCachingDisabled,
    };
  
  },
});

</script>
